import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentToken = localStorage.getItem('Token');
    const currentLang = localStorage.getItem('lang');
    // let currentToken = this.authenticationService.getGurrentToken();
    if (currentToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentToken}`,
          lang: currentLang ? currentLang : 'en'
        },
      });
    }
    return next.handle(request);
  }
}
